import type { BusinessOption } from '@/pages/Initiatives/List/Header/BusinessFilter/types'

const BUSINESS_FILTER_STORAGE_PREFIX = 'initiatives-business-filter'

export function getBusinessFilterStorageKey(userId: number) {
  return `${BUSINESS_FILTER_STORAGE_PREFIX}:${userId}`
}

function isBusinessOption(value: unknown): value is BusinessOption {
  if (typeof value !== 'object' || value == null) return false
  const { id, name } = value as Record<string, unknown>
  return typeof id === 'number' && typeof name === 'string'
}

export function loadPersistedBusinesses(userId: number): BusinessOption[] {
  try {
    const stored = globalThis.localStorage.getItem(
      getBusinessFilterStorageKey(userId)
    )
    if (stored == null) return []
    const parsed: unknown = JSON.parse(stored)
    return Array.isArray(parsed) ? parsed.filter(isBusinessOption) : []
  } catch {
    return []
  }
}

export function persistBusinesses(
  userId: number,
  businesses: BusinessOption[]
) {
  const storageKey = getBusinessFilterStorageKey(userId)
  try {
    if (businesses.length === 0) {
      globalThis.localStorage.removeItem(storageKey)
      return
    }
    globalThis.localStorage.setItem(storageKey, JSON.stringify(businesses))
  } catch {
    return
  }
}

export function clearPersistedBusinessFilters() {
  try {
    Object.keys(globalThis.localStorage)
      .filter((key) => key.startsWith(`${BUSINESS_FILTER_STORAGE_PREFIX}:`))
      .forEach((key) => globalThis.localStorage.removeItem(key))
  } catch {
    return
  }
}
